// Quick View
$(document).ready(function () {
  quickView();
});

function quickView() {
  $(".quick-view").click(function (e) {
    let content;
    e.preventDefault();
    var product_handle = $(this).data("handle");
    $("#quick-view").addClass(product_handle);
    $.ajax({
      url: "/products/" + product_handle,
    }).done(function (text) {
      const newDiv = document.createElement("div");
      newDiv.innerHTML = text;

      $(newDiv).find(".product__additional-wrapper").remove();
      $(newDiv).find(".share-buttons").remove();
      $(newDiv).find(".product__pickup-availabilities").remove();
      $(newDiv).find(".pickup-availability-preview").remove();
      $(newDiv).find(".product__text").remove();
      $(newDiv).find(".product__tags").remove();
      $(newDiv).find(".product__info-wrapper .modals").remove();
      $(newDiv).find(".js-media-sublist").remove();
      $(newDiv).find(".product__media-toggle").remove();
      $(newDiv).find(".product__media-icon").remove();
      $(newDiv).find(".product-recommendations--single").remove();
      let scripts = $(newDiv).find("script");

      for (let i = 0; i < scripts.length; i++) {
        let source = "" + $(scripts[i]).attr("src");

        if (source) {
          if (
            source.indexOf("copy.js") > -1 ||
            source.indexOf("pickup-availability.js") > -1
          ) {
            $(scripts[i]).remove();
          }
        }
      }

      $(newDiv).find(".product-form__submit").addClass("button--secondary");

      content = $(newDiv).find(".product-section");
      $("#quick-view .qv-wrapper").append(content);
    });
  });
}

document.addEventListener("shopify:section:load", function () {
  quickView();
});

(function () {
  const warmed = new Set();
  const warmTimers = new WeakMap();

  const storeRoot = () => {
    const root = window.Shopify?.routes?.root || "/";
    return root.endsWith("/") ? root : root + "/";
  };

  const warmQuickView = (button) => {
    const rawUrl = button?.getAttribute("data-product-url");
    if (!rawUrl) return;

    const url = new URL(rawUrl, window.location.origin);
    const key = url.pathname + url.search;
    if (warmed.has(key)) return;
    warmed.add(key);

    const productJsonUrl = url.pathname.replace(/\/$/, "") + ".js";
    fetch(productJsonUrl, {
      credentials: "same-origin",
      cache: "force-cache",
    }).catch(() => {});

    fetch(url.pathname + url.search, {
      credentials: "same-origin",
      cache: "force-cache",
    }).catch(() => {});
  };

  const scheduleWarm = (button) => {
    if (!button || warmTimers.has(button)) return;
    const timer = window.setTimeout(() => {
      warmTimers.delete(button);
      warmQuickView(button);
    }, 120);
    warmTimers.set(button, timer);
  };

  const cancelWarm = (button) => {
    const timer = warmTimers.get(button);
    if (!timer) return;
    window.clearTimeout(timer);
    warmTimers.delete(button);
  };

  document.addEventListener(
    "pointerover",
    (event) => {
      const button = event.target.closest(".quick-add-view[data-product-url]");
      if (button) scheduleWarm(button);
    },
    { passive: true }
  );

  document.addEventListener(
    "pointerout",
    (event) => {
      const button = event.target.closest(".quick-add-view[data-product-url]");
      if (button && !button.contains(event.relatedTarget)) cancelWarm(button);
    },
    { passive: true }
  );

  document.addEventListener(
    "focusin",
    (event) => {
      const button = event.target.closest(".quick-add-view[data-product-url]");
      if (button) warmQuickView(button);
    },
    { passive: true }
  );

  document.addEventListener(
    "touchstart",
    (event) => {
      const button = event.target.closest(".quick-add-view[data-product-url]");
      if (button) warmQuickView(button);
    },
    { passive: true }
  );

  document.addEventListener(
    "click",
    async (event) => {
      const add = event.target.closest(".sss-qv2 [data-qv-add]");
      if (!add || add.disabled) return;

      const variantId = Number(add.dataset.variantId);
      if (!variantId) return;

      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      const quickViewRoot = add.closest(".sss-qv2");
      const status = quickViewRoot?.querySelector("[data-qv-status]");
      const originalText = add.textContent;
      const cartDrawer = document.querySelector("cart-drawer");
      const sections = cartDrawer?.getSectionsToRender?.().map((section) => section.id) || [
        "cart-drawer",
        "cart-icon-bubble",
      ];

      add.disabled = true;
      add.textContent = "Adding…";
      if (status) status.textContent = "";

      try {
        const response = await fetch(storeRoot() + "cart/add.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          credentials: "same-origin",
          body: JSON.stringify({
            id: variantId,
            quantity: 1,
            sections,
            sections_url: window.location.pathname,
          }),
        });

        const data = await response.json();
        if (!response.ok) {
          throw new Error(data?.description || "Unable to add this item.");
        }

        add.textContent = "Added to Bag";
        if (status) status.textContent = "Added to your bag.";

        quickViewRoot?.querySelector("[data-qv-close]")?.click();

        if (cartDrawer?.renderContents && data.sections) {
          cartDrawer.renderContents(data);
        } else if (window.Shopify?.actions?.openCart) {
          await window.Shopify.actions.openCart();
        } else {
          document.querySelector("#cart-icon-bubble")?.click();
        }
      } catch (error) {
        add.disabled = false;
        add.textContent = originalText;
        if (status) {
          status.textContent = error?.message || "Unable to add this item.";
        }
      }
    },
    true
  );
})();